import { render } from "./MinistryUsers.vue?vue&type=template&id=f2d039e2&scoped=true"
import script from "./MinistryUsers.vue?vue&type=script&lang=js"
export * from "./MinistryUsers.vue?vue&type=script&lang=js"

import "./MinistryUsers.vue?vue&type=style&index=0&id=f2d039e2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d039e2"]])

export default __exports__